import { atom, DefaultValue } from 'recoil';

const localStorageEffect = key => ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
    }

    onSet(newValue => {
        if (newValue instanceof DefaultValue) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, JSON.stringify(newValue));
        }
    });
};

export const authAtom = atom({
    key: "authAtom",
    default: false,
    effects_UNSTABLE: [
        localStorageEffect('authAtom'),
    ]
});

export const authStsAtom = atom({
    key: "authStsAtom",
    default: 'open',
    effects_UNSTABLE: [
        localStorageEffect('authStsAtom'),
    ]
});

export const userAtom = atom({
    key: "userAtom",
    default: {},
});

export const roleAtom = atom({
    key: "roleAtom",
    default: {},
});

export const outletAtom = atom({
    key: "outletAtom",
    default: {},
});

export const subAtom = atom({
    key: "subAtom",
    default: {},
});

export const orgAtom = atom({
    key: "orgAtom",
    default: '',
});

export const paramsAtom = atom({
    key: "paramsAtom",
    default: {}
});